

// Material Kit 2 PRO React pages
import SignInBasic from "pages/Authentication/SignIn/Basic";

export default function SignInBasicPage() {
  return <SignInBasic />;
}
